
export default {
    name: "GridContainerBlok",
    props: {
        blok: {
            type: Object,
            required: true,
        },
    },
}
